import { createContext, useContext, useMemo, useState, type ReactNode } from "react";
import type { TimelineScale } from "./useTimelineMetrics";

interface TimelineScaleContextValue {
  scale: TimelineScale | null;
  setScale: React.Dispatch<React.SetStateAction<TimelineScale | null>>;
}

const TimelineScaleContext = createContext<TimelineScaleContextValue | null>(null);

export function TimelineScaleProvider({ children }: { children: ReactNode }) {
  const [scale, setScale] = useState<TimelineScale | null>(null);
  const value = useMemo(() => ({ scale, setScale }), [scale]);
  return (
    <TimelineScaleContext.Provider value={value}>
      {children}
    </TimelineScaleContext.Provider>
  );
}

export function useTimelineScaleContext(): TimelineScaleContextValue {
  const ctx = useContext(TimelineScaleContext);
  if (!ctx) {
    throw new Error(
      "useTimelineScaleContext must be used within <TimelineScaleProvider>",
    );
  }
  return ctx;
}
